var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-viewer"},[_c('div',{staticClass:"ik-image"},[_c('IKImage',{attrs:{"urlEndpoint":"https://ik.imagekit.io/l7yvb6qgi/","path":_vm.getFilename(_vm.image.public_id),"transformation":_vm.transformation}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }